/*
* 検索（エリアマップ）用
*/
$(function() {

  /*
  * エリア検索時、地図をクリックで下部チェックを入れる
  */
  $('.area-btn-list .area-item').on('click', function(e) {
    e.preventDefault();
    let index = $(this).data('area-id');
    $('.area-list input[data-area-id="' + index + '"]').attr("checked", true).prop("checked", true).change();
  });



  /*
  * マップクリック
  */
  $('.map-images').on('click', function(e) {
    e.preventDefault();
    let id = $(this).data('area-id');
    let isActive = $('#image-map-area-' + id).attr('class');
    if (isActive == 'active') {
      // 選択済みの時
      $('#image-map-area-' + id).attr('class', '');
      $('.area_discription-name .area_' + id).removeClass('active');
      $('.area-list input[data-area-id=' + id + ']').prop('checked', false);
    }
    else {
      // 未選択の時
      $('#image-map-area-' + id).attr('class', 'active');
      $('.area_discription-name .area_' + id).addClass('active');
      $('.area-list input[data-area-id=' + id + ']').prop('checked', true);
    }
    return false;
  });

  /*
  * エリア名クリック
  */
  $('.area-item').on('click', function(e) {
    // エリア名クリック時は、該当するエリアのチェックボックスも連動してチェックする
    let mapId = $(this).data('map-area-id');
    $('input[data-area-id="' + mapId + '"]').trigger("click");
  });

  /*
  * エリアチェック
  */
  $('.area-list-check').on('click', function(e) {
    checkMapColor();
  });

  /*
  * エリアチェックボックスの状態によってマップにクラス付与
  */
  function checkMapColor() {
    for(i=1; i<=6; i++) {
      // エリアチェックボックスの状態取得
      let checked = $('.area-list input[data-area-id=' + i + ']').prop('checked');
      if (checked) {
        // チェックされている
        $('#image-map-area-' + i).attr('class', 'active');
        $('.area-item.area_' + i + ' span').addClass('active');
      }
      else {
        // チェックされていない
        $('#image-map-area-' + i).attr('class', '');
        $('.area-item.area_' + i + ' span').removeClass('active');
      }
    }
  }

  // 画面読み込み時
  setTimeout(function() {
    checkMapColor();
  }, 500);

});
